<template>
    <component
            v-if="icon"
            :is="iconComponent"
            :data-icon="icon"
    />
</template>

<script>
    import CertificateIcon from 'images/units/certificate.svg';
    import Certificate2Icon from 'images/units/certificate_of_completion.svg';
    import VideoIcon from 'images/units/video.svg';
    import EbookIcon from 'images/units/ebook.svg';
    import QuizIcon from 'images/units/quiz.svg';
    import ExamIcon from 'images/units/exam.svg';
    import WrittenIcon from 'images/units/assignment.svg';
    import SurveyIcon from 'images/units/research.svg';
    import PdfIcon from 'images/units/pdf.svg';
    import EmbedIcon from 'images/units/embed.svg'; //
    import YoutubeIcon from 'images/units/youtube.svg';
    import SlideShareIcon from 'images/units/slideshare.svg';
    import UrlIcon from 'images/units/link.svg';
    import SoundcloudIcon from 'images/units/soundcloud.svg';
    import SoundIcon from 'images/units/sound.svg';
    import WordIcon from 'images/units/word.svg';
    import ExcellIcon from 'images/units/excell.svg';
    import PowerPointIcon from 'images/units/powerpoint.svg';
    import ZipIcon from 'images/units/zip.svg';
    import ScormIcon from 'images/units/scorm.svg';
    import ZoomMeetingIcon from 'images/units/zoom-meeting.svg';
    import ZoomWebinarIcon from 'images/units/zoom-webinar.svg';

    export default {
        name: "UnitIcon",
        props: {
            icon: {
                type: String,
                default: ""
            }
        },
        computed: {
            iconComponent () {
                return this.icon + "-icon";
            }
        },
        components: {
            "video-icon": VideoIcon,
            "ebook-icon": EbookIcon,
            "quiz-icon": QuizIcon,
            "exam-icon": ExamIcon,
            "written-icon": WrittenIcon,
            "survey-icon": SurveyIcon,
            "certification-icon": CertificateIcon,
            "certification2-icon": Certificate2Icon,
            "pdf-icon": PdfIcon,
            "embed-icon": EmbedIcon,
            "yt-icon": YoutubeIcon,
            "ss-icon": SlideShareIcon,
            "url-icon": UrlIcon,
            "soundcloud-icon": SoundcloudIcon,
            "sound-icon": SoundIcon,
            "word-icon": WordIcon,
            "excell-icon": ExcellIcon,
            "ppt-icon": PowerPointIcon,
            "zip-icon": ZipIcon,
            "scorm-icon": ScormIcon,
            "zoom-meeting-icon": ZoomMeetingIcon,
            "zoom-webinar-icon": ZoomWebinarIcon,
        }
    }
</script>
